<script>
    export let params;
    params; // Avoid warning

    import {fade} from 'svelte/transition'

    import TicketList from "./TicketList.svelte"
    import AdminActionLog from "./AdminActionLog.svelte"

    let ticketsSize = 0

</script>


<div class="col s12 m8 l7" in:fade={{duration: 500}}>
    <div class="container main-container">
        <h4>Active tickets ({ticketsSize})</h4>
        <TicketList bind:ticketsSize />
    </div>
</div>

<div class="col s12 m12 l3" in:fade={{duration: 500}}>
    <div class="main-container">
        <AdminActionLog />
    </div>
</div>
